import { motion } from "framer-motion";
import { Star } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Thabo Molefe",
      company: "Molefe Holdings",
      quote:
        "Mheshe Attorneys handled our property transfer with exceptional professionalism. The process was smooth, and communication was excellent throughout.",
      rating: 5,
    },
    {
      name: "Sarah van der Berg",
      company: "Tech Startup Founder",
      quote:
        "Their expertise in corporate law helped us structure our company correctly from day one. Highly recommended for any business legal needs.",
      rating: 5,
    },
    {
      name: "Antonio Silva",
      company: "Silva Imports SA",
      quote:
        "As an Angolan business owner operating in South Africa, their cross-border expertise was invaluable. They understood both legal systems perfectly.",
      rating: 5,
    },
  ];

  return (
    <section
      className="bg-white py-24 lg:py-32"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
            Client Testimonials
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl font-semibold text-charcoal leading-tight tracking-tighter">
            What Our Clients Say
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="testimonial-card bg-white p-8"
              data-testid={`testimonial-card-${index}`}
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 text-brand-gold fill-brand-gold"
                  />
                ))}
              </div>
              <blockquote className="text-charcoal/80 font-sans leading-relaxed mb-6">
                "{testimonial.quote}"
              </blockquote>
              <div className="border-t border-charcoal/10 pt-4">
                <p className="font-serif text-lg text-charcoal">
                  {testimonial.name}
                </p>
                <p className="text-charcoal/50 font-sans text-sm">
                  {testimonial.company}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
